namespace $ {
	const { rem, em, px, per } = $mol_style_unit
	const { hsla } = $mol_style_func

	const border_width = px(1)
	$mol_style_define($exso_sheets_site, {
		Info: {
			Content: {
				flexDirection: 'column',
			},
			border: {
				width: border_width,
				style: 'solid',
				color: $mol_theme.line,
				left: { width: $mol_gap.space, style: 'solid', color: $mol_theme.current },
			},
		},
		Info_title: {
			font: { weight: 'bold', size: rem(1.3) },
		},
		Body_content: {
			gap: $mol_gap.block,
		},
	})
}
